var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1C9.27614 1 9.5 0.776142 9.5 0.5C9.5 0.223858 9.27614 0 9 0C8.72386 0 8.5 0.223858 8.5 0.5C8.5 0.776142 8.72386 1 9 1ZM9.5 5.5C9.5 5.22386 9.27614 5 9 5C8.72386 5 8.5 5.22386 8.5 5.5V13.2929L4.35355 9.14645C4.15829 8.95118 3.84171 8.95118 3.64645 9.14645C3.45118 9.34171 3.45118 9.65829 3.64645 9.85355L8.64645 14.8536C8.84171 15.0488 9.15829 15.0488 9.35355 14.8536L14.3536 9.85355C14.5488 9.65829 14.5488 9.34171 14.3536 9.14645C14.1583 8.95118 13.8417 8.95118 13.6464 9.14645L9.5 13.2929V5.5ZM9 2C9.27614 2 9.5 2.22386 9.5 2.5V3.5C9.5 3.77614 9.27614 4 9 4C8.72386 4 8.5 3.77614 8.5 3.5V2.5C8.5 2.22386 8.72386 2 9 2ZM1 10.5C1 10.2239 0.776142 10 0.5 10C0.223858 10 0 10.2239 0 10.5V16C0 17.1046 0.895431 18 2 18H16C17.1046 18 18 17.1046 18 16V10.5C18 10.2239 17.7761 10 17.5 10C17.2239 10 17 10.2239 17 10.5V16C17 16.5523 16.5523 17 16 17H2C1.44772 17 1 16.5523 1 16V10.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.d0991d2f2358409117877f9cf4041f7a.svg";
export { ForwardRef as ReactComponent };